
import countriesJson from 'data/countries.json'
import regionsJson from 'data/regions.json'

export interface Country {
    id: number
    name: string
    code: string
}

export interface Region {
    id: number
    name: string
    code: string
    country_id: number
    country_code: string
}

const countries = countriesJson as Country[]
const regions = regionsJson as Region[]

const normalizeGeoValue = (value?: string | null): string =>
    (value ?? '')
        .trim()
        .toLowerCase()
        .replace(/\./g, '')
        .replace(/\s+/g, ' ')

export const getAllCountries = (): Country[] => countries

export const getCountryOptions = () =>
    countries.map(country => ({
        value: country.code,
        label: country.name
    }))

export const findCountry = (
    value?: string | null
): Country | undefined => {
    const normalized = normalizeGeoValue(value)

    if (!normalized) return undefined

    return countries.find(
        country =>
            normalizeGeoValue(country.code) === normalized ||
            normalizeGeoValue(country.name) === normalized
    )
}

export const findRegion = (
    country: Country | undefined,
    value?: string | null
): Region | undefined => {
    const normalized = normalizeGeoValue(value)

    if (!country || !normalized) return undefined

    return regions.find(
        region =>
            region.country_id === country.id &&
            (
                normalizeGeoValue(region.code) === normalized ||
                normalizeGeoValue(region.name) === normalized
            )
    )
}

export const getCountryCode = (
    value?: string | null
): string => findCountry(value)?.code ?? ''

export const getRegionCode = (
    countryValue?: string | null,
    regionValue?: string | null
): string => {
    const country = findCountry(countryValue)

    return findRegion(country, regionValue)?.code ?? ''
}

export const getRegionsByCountry = (
    countryValue?: string | null
): Region[] => {
    const country = findCountry(countryValue)

    if (!country) return []

    return regions.filter(
        region => region.country_id === country.id
    )
}

export const getRegionOptions = (
    countryValue?: string | null
) =>
    getRegionsByCountry(countryValue).map(region => ({
        value: region.code,
        label: region.name
    }))
